<template>
  <div class="platform-maintenance">
    <HelperViewStatus
      :title="helperViewData.title"
      :description="helperViewData.description"
      :status="helperViewData.status"
      button-label="Tentar novamente"
      @click="redirectToOverview"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

import {
  HelperViewContextual,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';

import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

@Component({
  components: {
    HelperViewContextual,
    HelperViewStatus
  }
})
export default class PlatformMaintenance extends Vue {
  private created() {
    if (!this.isPlatformMaintenance) this.redirectToOverview();
  }

  get isPlatformMaintenance() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.PLATFORM_MAINTENANCE);
  }

  get helperViewData() {
    return {
      title: 'Plataforma em manutenção',
      status: 'alert',
      description:
        'Estamos passando por uma manutenção na nossa plataforma, mas não se preocupe, logo estaremos de volta.'
    };
  }

  redirectToOverview() {
    window.location.href = '/app/#/v3';
  }
}
</script>

<style lang="less" scoped>
.platform-maintenance {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.helper-view {
  max-width: 592px;
}
</style>
